import { customService, customServiceWechat } from '@/api/center'
import store from '@/store'
import router from '@/router'
import { apiPactManagePact, apiPactManageSignedPact } from '@/api/user'
export const navToService = async (val) => {
  if (store.state.channel === 'baidu') {
    window.swan.webView.navigateTo({
      url: '/pages/webview/webview?type=customService'
    })
  } else if (store.state.channel === 'gac') {
    location.href = 'https://kf-web.etczs.net/dzfront/web/home?token=qeMRzquiIn63&showChat=true&layout=true'
  } else if (['aion', 'hyptec'].includes(store.state.channel)) {
    location.href = 'https://kf-web.etczs.net/dzfront/web/home?token=qeMRzquiIn63&showChat=true&layout=true&hasBackBtn=1'
  } else {
    try {
      const isObject = (value) => { return Object.prototype.toString.call(value) === '[object Object]' }
      let objData;
      if(val == 'applyB'){
        objData = await customServiceWechat()
      }else {
        objData = await customService()
      }
      const customServiceBaseUrl = objData.url + '?'
      objData.param_query = isObject(objData.param_query) ? JSON.stringify(objData.param_query) : objData.param_query
      objData.param_service_visitor = isObject(objData.param_service_visitor) ? JSON.stringify(objData.param_service_visitor) : objData.param_service_visitor
      objData.param_account = isObject(objData.param_account) ? JSON.stringify(objData.param_account) : objData.param_account
      let paramUrl = `paramServiceVisitor=${objData.param_service_visitor}&paramAccount=${objData.param_account}&paramServiceChat=${objData.param_service_chat}&questionFlag=${objData.question_flag}&paramQuery=${objData.param_query}` 
      let repdata = paramUrl.replace(/"/g,"'")
      paramUrl = encodeURI(repdata)
      const webViewUrl = customServiceBaseUrl + `tenantToken=${objData.tennat_token}&siteId=${objData.site_id}&skillsetId=${objData.skill_set_id}&customFlag=1&` + paramUrl +  `&showChat=true&layout=true&token=${objData.token}&externalId=${objData.externalId}`

      location.href = webViewUrl
      console.log('webViewUrl', webViewUrl)
    } catch (e) {
      console.error(e)
    }
  }

}

export const sleep = time => {
  return new Promise(resolve => {
    if (!time) resolve()
    setTimeout(() => {
      resolve()
    }, time)
  })
}

export const getProtocolList = protocolList => {
  const data = {
    pactSn: protocolList.filter(item => item).map(ele => ele.pactSn).join(',')
  }
  return apiPactManagePact(data)
}

export function showProtocol(protocol) {
  // pactContent
  let hasBackBtn = 0
  if (['aion', 'hyptec'].includes(store.state.channel)) {
    // 埃安没有导航栏，跳过去需要增加返回按钮
    hasBackBtn = 1
  }
  location.href = (`${process.env.VUE_APP_H5_PUB_HOST}/some/viewPdf/viewPdf.html?url=${protocol.pactContent}&name=${protocol.pactName}&hasBackBtn=${hasBackBtn}`)
}

// 获取页面协议的最新版本
/**
 *
 *
 * @export
 * @param {*} protocolList 协议列表
 * @param {string} carList 需要签约的车辆列表
 * @param {*} bussModule 协议类型 1 申办 2 售后
 * @returns
 */
 export async function submitProtocolAgree(protocolList, {
  carList,
  bussModule = '1',
  bussSn,
  plateNo
}) {
  const pactInfo = []
  const pactOrderInfo = []
  protocolList.forEach(ele => {
    pactInfo.push({
      pactSn: ele.pactSn,
      pactId: ele.id,
    })
  })
  if (!carList) { // 申办场景 只有一辆车进行签约
    pactOrderInfo.push({
      bussSn: bussSn,
      plateNo: plateNo,
      bussModule
    })
  } else { // 微众改签场景  多辆车同时签约
    carList.forEach((ele) => {
      pactOrderInfo.push({
        bussSn: ele.order_sn,
        plateNo: ele.plate_no,
        bussModule
      })
    })
  }

  const terminalInfo = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    vendor: navigator.vendor,
    platform: navigator.platform || navigator.userAgentData.platform,
  }
  // getState, getStore
  return new Promise((resolve, reject) => {
    apiPactManageSignedPact({
      pactInfo: pactInfo,
      pactOrderInfo: pactOrderInfo,
      terminalInfo: JSON.stringify(terminalInfo),
      // bussModule: '1',
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        console.warn(err)
        reject(err)
      })
  })
}

/**
 * 加载脚本
 * @param {*} scriptList 脚本列表
 */
export function loadScripts(scriptList) {
  const promises = scriptList.map(item => {
    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = item
      script.onload = resolve
      document.head.appendChild(script)
    })
  })
  return Promise.all(promises)
}

// 小驼峰转下划线
export function camelToUnderscore(obj) {
  const isObject = (value) => { return Object.prototype.toString.call(value) === '[object Object]' }
  if (isObject(obj)) {
    let newObj = {}
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        const item = obj[key]
        const newKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
        newObj[newKey] = item
      }
    }
    return newObj
  } else {
    return obj
  }
}

// 获取状态栏高度
export function getStatusBarHeight() {
  let statusBarHeight = 0;

  if (window.visualViewport) {
    statusBarHeight = window.visualViewport.offsetTop;
  } else if (window.screen && window.matchMedia('(display-cutout: constant)').matches) {
    const devicePixelRatio = window.devicePixelRatio;
    const screenHeight = window.screen.height;
    statusBarHeight = Math.round(24 * devicePixelRatio); // 这里的24需要根据设备实际情况进行调整
  }
  console.error('this.statusBarHeightthis.statusBarHeight', window.visualViewport, window.visualViewport.offsetTop, window)

  return +statusBarHeight;
}

// 设定当前页为首页
export function setIndexPage() {
  const currentPath = router.currentRoute.value.fullPath
  console.log('setIndexPage', currentPath)
  sessionStorage.setItem('INDEX_ROUTE_PATH', currentPath)
}

// 返回首页  各个渠道首页不尽相同
export function backToIndex() {
  let indexRoutePath = sessionStorage.getItem('INDEX_ROUTE_PATH') || ''
  const currentPath = router.currentRoute.value.path
  switch (store.state.channel) {
    case 'dongfeng':
    case 'nissan7':
      return window.location.replace('https://ccs5h5.dongfeng-nissan.com.cn/ccs5LowCode/preview?page_code=H5N000210')
    case 'baidu':
      indexRoutePath = '/'
      break
    case 'gac':
    case 'aion':
    case 'hyptec':
      indexRoutePath = indexRoutePath || '/enterprise/prodDetail'
      break
    default:
      let applyInfo = JSON.parse(localStorage.getItem('applyInfo'))
      let path = ''
      if (applyInfo?.applyType == 'emall') {
        path = '/third/emall'
      } else if (applyInfo?.applyType == 'wechat') {
        path = '/third/coupon'
      } else if (applyInfo?.applyType == 'bank') {
        path = '/third/bank'
      }
      if (path) {
        const query = new URLSearchParams(applyInfo).toString()
        indexRoutePath = path + '?' + query
      }
      break
  }

  router.replace(indexRoutePath || '/') 
}

// 获取hyptec用户信息
let _getHyptecInfo = null
export function getHyptecInfo() {
  _getHyptecInfo = _getHyptecInfo || new Promise(async (resolve, reject) => {
    // return resolve({
    //   userId: '2211618',
    //   mobile: '18664847484',
    // })
    window.hyptecCallback = res => {
      console.warn('hyptecCallback res =>', res)
      // 判断res是否为JSON字符串
      let parsedRes
      try {
        parsedRes = typeof res === 'string' ? JSON.parse(res) : res
      } catch (e) {
        console.warn('res 不是合法的 JSON 字符串')
        parsedRes = res
      }
      resolve(parsedRes)
      _getHyptecInfo = null
    }
    try {
      console.log(window)
      console.warn('GACNativeApp getHyptecAppInfo start', window.GACNativeApp)
      if (!window.GACNativeApp) {
        let count = 0
        while (!window.GACNativeApp) {
          console.warn('GACNativeApp is not defined, wait 300ms')
          await sleep(300)
          count++
          if (count > 10) {
            reject('GACNativeApp is not defined after 3000ms')
            break
          }
        }
      }
      if (window.GACNativeApp) {
        window.GACNativeApp.invoke('AppInfo','{"callBack":"hyptecCallback"}')
      }
    } catch (error) {
      console.error('GACNativeApp getHyptecAppInfo Error==>', error)
      reject(error)
    }
  })
  return _getHyptecInfo
}

/**
 * 比较两个版本号字符串的大小
 * @param {string} v1 版本号1
 * @param {string} v2 版本号2
 * @returns {number} 1: v1 > v2; 0: v1 === v2; -1: v1 < v2
 */
export function compareVersion(v1, v2) {
  const parse = (v) => String(v).split('.').map(n => parseInt(n, 10) || 0)
  const arr1 = parse(v1)
  const arr2 = parse(v2)
  const len = Math.max(arr1.length, arr2.length)

  for (let i = 0; i < len; i++) {
    const a = arr1[i] || 0
    const b = arr2[i] || 0
    if (a > b) return 1
    if (a < b) return -1
  }
  return 0
}
